// Components
import IconButton from '../../../atoms/IconButton/IconButton';
// Utils
import cn from '../../../../utils/cn';
// Styles
import styles from './BooleanCell.module.css';
import commonStyles from '../TableCellCommon.module.css';

/**
 * BooleanCell component for displaying and editing boolean values in table cells
 * @param {object} props - Component props
 * @param {boolean} props.value - The boolean value
 * @param {boolean} [props.disabled=false] - Whether the cell is disabled
 * @param {Align} [props.align='center'] - Alignment
 * @param {VerticalAlign} [props.verticalAlign='middle'] - Vertical alignment
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {string} props.trueIcon
 * @param {string} props.falseIcon
 * @returns {JSX.Element} BooleanCell component
 */
export default function BooleanCell({
  value = false,
  trueIcon = '',
  falseIcon = '',
  disabled = false,
  align = 'center',
  verticalAlign = 'middle',
  className = '',
}) {
  const iconName = value ? trueIcon : falseIcon;

  return (
    <div
      className={cn([
        styles['boolean-cell'],
        className,
        align && commonStyles[`cell-align-${align}`],
        verticalAlign && commonStyles[`cell-vertical-align-${verticalAlign}`],
      ])}
    >
      <IconButton
        icon={iconName}
        disabled={disabled}
        className={styles['boolean-button']}
        color="no-background"
      />
    </div>
  );
}
